import { createStyles, Theme } from '@material-ui/core/styles';

const style = (theme: Theme) => createStyles({

    selectRoot: {
        '& div': {
            width: '100%',
            display: 'flex',
            alignItems: 'center',

            '&:focus': {
                background: 'rgba(0, 0, 0, 0)',
            },

            '& img': {
                marginRight: theme.spacing.unit,
            },
        },

        '& svg': {
            marginTop: 2,
            marginRight: -6,
            fontSize: 20,
        },
    },

    image: {
        marginRight: theme.spacing.unit,
        width: 16,
        height: 16,
    },

});

export default style;
